// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Us4","importantInfo":"styles_importantInfo__13GS5"};